
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return require("private-next-pages/register/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register"])
      });
    }
  